import type { LabSettings, MotionProfile, RendererLoad } from "../types";

const storageKey = "experience-lab:settings";

export const defaults: LabSettings = {
  profile: "system",
  intensity: 0.72,
  load: "medium",
  hud: true,
};

export function resolveReducedMotion(
  profile: MotionProfile,
  systemPrefersReduced: boolean,
) {
  return profile === "reduced" || (profile === "system" && systemPrefersReduced);
}

export function objectCount(load: RendererLoad) {
  return { light: 28, medium: 96, stress: 320 }[load];
}

export function readSettings(): LabSettings {
  if (typeof window === "undefined") return defaults;
  try {
    return { ...defaults, ...JSON.parse(localStorage.getItem(storageKey) ?? "{}") };
  } catch {
    return defaults;
  }
}

export function writeSettings(settings: LabSettings) {
  localStorage.setItem(storageKey, JSON.stringify(settings));
}
